export default function Features() {
  const features = [
    {
      number: "01",
      title: "本体料金が",
      highlight: "無料",
      description: "初期契約金・搬入設置費・設定費は別途発生致します。"
    },
    {
      number: "02",
      title: "設置 日から1年以降は解約金無しでいつでも",
      highlight: "解約OK",
      description: "1年未満の場合には基本本体料金を未経過月数分ご請求となります。"
    },
    {
      number: "03",
      title: "納品機械は",
      highlight: "中古品",
      subtitle: "、メンテナンス部品は",
      highlight2: "新品",
      description: "最新モデルから2〜3世代前の複合機をお届け致します。 MacOS等へも対応可能です。"
    },
    {
      number: "04",
      title: "カウンター保守料金が",
      highlight: "カクヤス",
      description: "設置エリアにより料金は変動致しますが、中古機械は最高水準の料金設定となっております。"
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-[#2D2D2D] to-[#1A1A1A]">
      <div className="max-w-6xl mx-auto px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-white mb-3">
            <a href="#features" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              プラン概要
            </a>
          </h2>
          <div className="w-80 h-1 bg-gradient-to-r from-[#14B8A6] to-transparent"></div>
        </div>

        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-2">
            0円コピー <span className="text-[#14B8A6]">4つ</span>の強み
          </h3>
        </div>

        <div className="space-y-8">
          {features.map((feature, index) => (
            <div key={index} className="flex gap-6 items-start">
              <div className="flex-shrink-0 w-24 h-24 bg-[#14B8A6] rounded-lg flex flex-col items-center justify-center">
                <div className="text-white text-xs font-medium mb-1">POINT</div>
                <div className="text-white text-3xl font-bold">{feature.number}</div>
              </div>

              <div className="flex-1 bg-[#2D2D2D] rounded-lg p-6 border border-gray-700">
                <h4 className="text-2xl text-white mb-3">
                  {feature.title}
                  <span className="text-[#14B8A6] font-bold">{feature.highlight}</span>
                  {feature.subtitle && (
                    <>
                      {feature.subtitle}
                      <span className="text-[#14B8A6] font-bold">{feature.highlight2}</span>
                    </>
                  )}
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
